import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index.vue'
import login from '@/pages/login/index.vue'
import qrcode from '@/pages/qrcode/index.vue'
Vue.use(Router);


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/qrcode/:type',    // wechat or alipay
      name: 'qrcode',
      component: qrcode,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});


export default router;
